import { defineMessages } from 'react-intl-next';

export default defineMessages({
	moreMenuTriggerLabel: {
		id: 'navigation.global-more-menu.trigger-label',
		defaultMessage: 'More',
		description: 'Default label text for the global more menu trigger button',
	},
});
